const TOKEN_STORAGE_KEY = 'cellfie:access-token';
let inMemoryToken: string | null = null;
let hasLoggedMissingToken = false;

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

export function getAccessToken(): string | null {
  if (inMemoryToken) {
    return inMemoryToken;
  }

  if (isBrowser()) {
    try {
      const storedToken = window.sessionStorage.getItem(TOKEN_STORAGE_KEY);
      if (storedToken) {
        inMemoryToken = storedToken;
        return storedToken;
      }
    } catch (error) {
      console.warn('[auth] Unable to read sessionStorage token', error);
    }
  }

  if (!hasLoggedMissingToken && import.meta.env.DEV) {
    console.warn(
      '[auth] Access token not set yet; login is required before protected requests succeed.'
    );
    hasLoggedMissingToken = true;
  }

  return null;
}

export function setAccessToken(token: string): string {
  const normalizedToken = token.trim();

  if (!normalizedToken) {
    throw new Error('Access token must be a non-empty string.');
  }

  inMemoryToken = normalizedToken;

  if (isBrowser()) {
    try {
      window.sessionStorage.setItem(TOKEN_STORAGE_KEY, normalizedToken);
    } catch (error) {
      console.warn('[auth] Unable to persist token in sessionStorage', error);
    }
  }

  return normalizedToken;
}

export function clearAccessToken(): void {
  inMemoryToken = null;

  if (isBrowser()) {
    try {
      window.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    } catch (error) {
      console.warn('[auth] Unable to clear sessionStorage token', error);
    }
  }
}

export function resetMissingTokenLog(): void {
  hasLoggedMissingToken = false;
}
